var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoveFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.372,
    height: 60.372,
    viewBox: "0 0 60.372 60.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.42,
    x2: 0.5,
    y2: 0.582,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c334"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-99.207 -79.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(50.716 10.716)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M108.863,98.842A30.186,30.186,0,1,1,78.676,68.655,30.185,30.185,0,0,1,108.863,98.842Z",
    transform: "translate(0)",
    fill: "#e4c73d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M81.328,128.79a27.3,27.3,0,1,1,27.3-27.3A27.3,27.3,0,0,1,81.328,128.79Z",
    transform: "translate(-2.65 -2.65)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(49.792 80.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M130.226,96.412c-4.925-9.387-14.034-2.731-12.439,4.284,1.259,5.513,7.31,13.334,7.31,13.334.871-.308,9.3-3.348,13.321-7.324C143.533,101.648,139.423,91.141,130.226,96.412Z",
    transform: "translate(-82.874 -91.778)",
    fill: "#cc342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M61.4,96.412c4.926-9.387,14.036-2.731,12.439,4.284-1.257,5.513-7.307,13.334-7.307,13.334-.872-.308-9.3-3.348-13.323-7.324C48.1,101.648,52.206,91.141,61.4,96.412Z",
    transform: "translate(-50.987 -91.778)",
    fill: "#cc342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M84.068,145.467c-.755-.249-1.464.569-1.245,1.443a12.428,12.428,0,0,0,12.267,9c5.979,0,10.972-3.841,12.268-9,.22-.874-.489-1.692-1.245-1.443a36.212,36.212,0,0,1-22.045,0Z",
    transform: "translate(-66.207 -117.456)",
    fill: "#5f380f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M100.99,155.481a6.425,6.425,0,0,0-5.883,3.888,13.463,13.463,0,0,0,11.766,0A6.422,6.422,0,0,0,100.99,155.481Z",
    transform: "translate(-72.106 -122.271)",
    fill: "#cc342f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveFeedback);
export default __webpack_public_path__ + "static/media/loveFeedback.9b2fdf891b7eab893c144ebb845ee198.svg";
export { ForwardRef as ReactComponent };